import React from 'react';
import NoteCard from '../components/NoteCard';
import ConnectButton from '../components/ConnectButton';
import notesData from '../assets/data.json';

const Notes = () => {
  const filteredNotes = notesData.filter(note => note.articleUrl);
  return (
    <div className="notes-container">
      {filteredNotes.reverse().map((note) => (
        <NoteCard 
          key={note.id} 
          imageUrl={note.imageUrl} 
          title={note.title} 
          format={note.format}
          articleUrl={note.articleUrl}
          videoUrl={note.videoUrl}
          id={note.id} 
        />
      ))}

      <div className="section-separator"></div>

      <div>
        <div className="more-title-note">
          <h1>IDEAS...</h1>
        </div>
        <div className="more-text-note">
          <h1>Got a project?</h1>
          <h3>LET'S LEARN MORE ABOUT IT!</h3>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <ConnectButton />
          </div>
        </div>
      </div>

    </div>
  );
};

export default Notes;